import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getBookingDetail = async (bookingId) => {
  return await apiClient.get(`${ENDPOINTS.BOOKINGS}/${bookingId}`);
};
